import gql from 'graphql-tag';

export const userOpinionVendorVariantFragmentName = 'userOpinionVendorVariant';
export const userOpinionVendorVariantFields = gql`
  fragment userOpinionVendorVariant on UserOpinionVendorVariantModel {
    id
    opinion
    vendorVariantId
  }
`;

export const vendorVariantFragmentName = 'productInfo';
export const vendorVariantFields = gql`
  fragment productInfo on VendorVariantModel {
    id
    sku
    title
    isOnSale
    freeShippingBadge
    image {
      id
      uri
    }
    images {
      id
      uri
    }
    price: currentPrice
    retailPrice {
      id
      price
    }
    vendor {
      id
      name
    }
    availability
    userOpinion {
      ...userOpinionVendorVariant
    }
    taxonomy {
      id
      title
    }
    hasBeenPurchased
    productUrl
    productGroupUrl
    weblink
    groupCount
    productDetailsUrl
    attributeFamilies {
      id
      title
      parent {
        id
        title
      }
      vendorVariantCount
    }
    parentTaxonomyCategory {
      title
    }
    saleOnSalePrice {
      price
      percentage
    }
    totalDiscountPercent
    vendorTieredDiscountCode {
      code
      discountType
      maxSavingsPercentage
      minSavingsValue
      maxSavingsValue
      lowestDiscountPrice
      highestDiscountPrice
      discountText
      discountTerms
    }
  }

  ${userOpinionVendorVariantFields}
`;
